import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { GraduationCap, List, X } from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/#tool", label: "Rubric Generator" },
  { to: "/#downloads", label: "Free Downloads" },
  { to: "/#resources", label: "Printable Resources" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

function navClass(isActive) {
  return [
    "font-semibold text-sm tracking-tight transition-colors",
    isActive ? "text-[#0A0A0A]" : "text-[#475569] hover:text-[#0A0A0A]",
  ].join(" ");
}

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-[#E5E7EB]"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-4 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-home-link"
          className="flex items-center gap-2.5 group"
          onClick={() => setOpen(false)}
        >
          <span className="w-10 h-10 bg-[#A8B5A2] rounded-xl flex items-center justify-center shadow-sm group-hover:shadow-md transition-shadow">
            <GraduationCap size={22} weight="bold" />
          </span>
          <span className="font-display font-black text-xl md:text-2xl tracking-tight">
            TeacherToolsLab
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((item) => (
            item.to.startsWith("/#") ? (
              <a
                key={item.to}
                href={item.to}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={navClass(false)}
              >
                {item.label}
              </a>
            ) : (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) => navClass(isActive)}
              >
                {item.label}
              </NavLink>
            )
          ))}
        </nav>

        <a
          href="/#tool"
          data-testid="header-cta"
          className="hidden md:inline-flex items-center bg-[#0A0A0A] text-white rounded-xl px-4 py-2 font-semibold text-sm hover:bg-[#1E1E1E] transition-colors shadow-sm"
        >
          Generate a Rubric
        </a>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          className="lg:hidden p-2 rounded-lg hover:bg-[#F1F5F9] transition-colors"
        >
          {open ? <X size={24} weight="bold" /> : <List size={24} weight="bold" />}
        </button>
      </div>

      {open ? (
        <nav
          data-testid="mobile-nav"
          className="lg:hidden border-t border-[#E5E7EB] bg-white px-5 py-4 flex flex-col gap-3"
        >
          {NAV.map((item) =>
            item.to.startsWith("/#") ? (
              <a
                key={item.to}
                href={item.to}
                onClick={() => setOpen(false)}
                className="text-base font-semibold text-[#0A0A0A] py-1"
              >
                {item.label}
              </a>
            ) : (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-base font-semibold py-1 ${isActive ? "text-[#0A0A0A]" : "text-[#475569]"}`
                }
              >
                {item.label}
              </NavLink>
            )
          )}
          <a
            href="/#tool"
            onClick={() => setOpen(false)}
            className="mt-2 inline-flex justify-center bg-[#0A0A0A] text-white rounded-xl px-4 py-3 font-semibold"
          >
            Generate a Rubric
          </a>
        </nav>
      ) : null}
    </header>
  );
}
